<template>

  <div id="lab-option" class="lab-option">

    <div class="row">

      <div class="FRNW btn-line">

        <ModernButtonVue
          :disabled="!canUpdate"
          :btnText="'Update'"
          :clickFunc="update"
          :btnSize="'small'"
        />
        <ModernButtonVue
          v-show="!optionObj.new"
          :btnText="'Remove Option'"
          :btnSize="'small'"
          :backgroundColor="'#F4CCCC'"
          :clickFunc="remove"
          :title="'Removes option permanently'"
        />
      </div>

      <!-- OPTION TEXT -->
      <div class="line FRNW">
        <div class="key">
          Option Text:
        </div>
        <div class="value" >
          <input 
            class="modern-input"
            type="text"
            v-model="optionObj.optionText"
          >
        </div>
      </div>

      <!-- COST IN DOLLARS -->
      <div class="line FRNW">
        <div class="key">
          Cost ($):
        </div>
        <div class="value" >
          <input 
            class="modern-input"
            type="Number"
            v-model="optionObj.costDollars"
          >
        </div>
      </div>

    </div>

  </div>
  
</template>

<script>
import ModernButtonVue from './basicComponents/ModernButton.vue';

const API = process.env.VUE_APP_API_URL;
let NOTIFICATION;


export default {
  name: 'LabOptionComponent',
  components: {
    ModernButtonVue,
  },
  props: {
    optionObj: Object,
    mainKey: String,
    labOptionsId: String,
    userId: String,
    removeOption: Function,
    fetchUser: Function,
  },
  data () {
    return {
      optionObjCopy: {},

    }
  },
  computed: {
    canUpdate() {
      const arr = Object.keys( this.optionObj );
      return arr.some( key => {
        return this.optionObj[key]?.toString() !== this.optionObjCopy[key]?.toString()
      } );
    }
  },  
  methods: {
    update() {

      const data = {
        key: this.mainKey,
        optionObj: this.optionObj,
        labOptionsId: this.labOptionsId,
        userId: this.userId
      };
      this.axios
        .post( API + '/api/labOptions/updateOption', data )
        .then( res => {

          // reset values to be the same to disable update buton
          // this.optionObjCopy = JSON.parse( JSON.stringify( this.optionObj ) );

          const cb = () => {
            this.optionObjCopy = JSON.parse( JSON.stringify( this.optionObj ) );
            this.$forceUpdate();
          };

          this.fetchUser( cb );
          // this.optionObjCopy = JSON.parse( JSON.stringify( this.optionObj ) );
        })
        .catch( e => console.log(e) );
    },

    remove() {
      const data = {
        key: this.mainKey,
        labOptionsId: this.labOptionsId,
        optionObjId: this.optionObj._id
      };

      this.removeOption( data );

      // this.axios
      //   .post( API + '/api/labOptions/updateOption', data )
    }
  },
  mounted() {
    this.optionObjCopy = JSON.parse( JSON.stringify( this.optionObj ) );
  }
}

</script>

<style>
/* // about-section is used in UserAccount */
.lab-option, .about-section {
  display: flex;
  flex-direction: column;
  background-color: gainsboro;
  /* background-color: var(--fla-gray); */
  /* margin: 0 20% 1rem 20%; */
  /* margin: 0 var(--margin-default) 0 var(--margin-default); */
  border-radius: 10px;
  margin-bottom: 1rem;
  
}

.row {
  display: flex;
  flex-direction: column;
}

.red:not(:hover) {
  background-color: #F4CCCC !important;

}
</style>